import { ofType } from 'redux-observable'
import { switchMap } from 'rxjs/operators'
import { from } from 'rxjs'
import UserDataActions from '../Core/Redux/UserDataRedux'
import { ProductTypes } from '../Core/Redux/ProductRedux'
import FilterActions from '../Core/Redux/FilterRedux'
import ValidationActions from '../Core/Redux/ValidationRedux'
import GTMActions from '../Core/Redux/GTMRedux'
import moment from '../Core/Moment'

export default [
  (action$) => {
    return action$.pipe(
      ofType(ProductTypes.INIT_PRODUCT),
      switchMap(({ pathName }) => {
        // set insurance start implicitly to today
        const insuranceStart = {
          insuranceStart: moment()
            .endOf('day')
            // .subtract(30, 'minutes')
            .format('YYYY-MM-DDTHH:mm'),
        }

        const actions = [
          UserDataActions.onChangeData(insuranceStart),
          ValidationActions.onChangeShowValidationErrorPanel(false),
          FilterActions.refreshEnabledCalculators(), // todo epic is not connected
          ValidationActions.onResetValidationErrors(),
          GTMActions.setGtmPageView(pathName, document.title),
        ]

        return from(actions)
      }),
    )
  },

  // todo cannot be used, because it will be called on every page refresh
  // (action$) => {
  //   return action$.pipe(
  //     ofType(REHYDRATE),
  //     switchMap((action) => {
  //       const rehydrated = action.payload && action.payload._persist && action.payload._persist.rehydrated
  //       const userData = action.payload && action.payload.userData && action.payload.userData.data
  //
  //       if (rehydrated && userData) {
  //         const { insuranceStart } = userData
  //
  //         const newUserData = pipe(
  //           assoc(
  //             'insuranceStart',
  //             insuranceStart && moment().isSameOrAfter(moment(insuranceStart), 'day')
  //               ? moment().endOf('day').subtract(30, 'minutes').format('YYYY-MM-DDTHH:mm')
  //               : insuranceStart,
  //           ),
  //           assoc('elCommunicationAgreed', false),
  //           assocPath(['policyHolder', 'email'], ''),
  //         )(userData)
  //
  //         // console.log('UserDataActions.onChangeData(newUserData)', UserDataActions.onChangeData(newUserData))
  //
  //         return of(UserDataActions.onChangeData(newUserData))
  //       }
  //
  //       return EMPTY
  //     }),
  //   )
  // },
]
